import * as Yup from 'yup';
import VALUE_TYPES from '../../../configs/ValueTypeConstants';

export const InitialCompanyState = {
    name: null,
    address1: null,
    address2: null,
    po_box: null,
    telephone1: null,
    telephone2: null,
    fax1: null,
    fax2: null,
    email: null,
    website: null,
    trn_no: null,
    established_on: undefined,
    image_url: null,
};

export const CompanySchema = Yup.object().shape({
    name: Yup.string().required(),
    address1: Yup.string().required(),
    address2: Yup.string().nullable(),
    po_box: Yup.string().required(),
    telephone1: Yup.string().required(),
    telephone2: Yup.string().nullable(),
    fax1: Yup.string().nullable(),
    fax2: Yup.string().nullable(),
    email: Yup.string().nullable().email(),
    website: Yup.string().nullable(),
    trn_no: Yup.string().nullable(),
    established_on: Yup.date().nullable(),
    image_url: Yup.string().nullable(),
});

export const FormFields = [
    { name: "name", title: "Name", required: true, type: VALUE_TYPES.TEXT },
    { name: "po_box", title: "Po Box", required: true, type: VALUE_TYPES.TEXT },
    { name: "telephone1", title: "Telephone 1", required: true, type: VALUE_TYPES.TEXT },
    { name: "telephone2", title: "Telephone 2", required: false, type: VALUE_TYPES.TEXT },
    { name: "fax1", title: "Fax 1", required: false, type: VALUE_TYPES.TEXT },
    { name: "fax2", title: "Fax 2", required: false, type: VALUE_TYPES.TEXT },
    { name: "email", title: "Email", required: false, type: VALUE_TYPES.TEXT },
    { name: "website", title: "Website", required: false, type: VALUE_TYPES.TEXT },
    { name: "trn_no", title: "TRN NO", required: false, type: VALUE_TYPES.TEXT },
    { name: "established_on", title: "Established On", required: false, type: VALUE_TYPES.DATEPICKER },
    { name: "address1", title: "Address 1", required: true, type: VALUE_TYPES.TEXTAREA },
    { name: "address2", title: "Address 2", required: false, type: VALUE_TYPES.TEXTAREA },
];
